import { CustomConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { DateTimeConverter } from './converters/datesConverters';
import { ModeReglement } from './mode-reglement';

@JsonObject
export class PrixAppel {
  constructor (

    numArticle?: string,
    valeur?: number,
    dateCommande?: Date,
    dateLivraison?: Date,
    datepaiement?: Date,
    modeReglement?: ModeReglement,
    codeRegion?: string
  ) {
    this.numArticle = numArticle as any;
    this.valeur = valeur as any;
    this.dateCommande = dateCommande as any;
    this.dateLivraison = dateLivraison as any;
    this.datepaiement = datepaiement as any;
    this.modeReglement = modeReglement as any;
    this.codeRegion = codeRegion as any;
  }

  @JsonProperty(String)
  numArticle: string;

  @JsonProperty(Number)
  valeur: number;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateTimeConverter)
  dateCommande: Date;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateTimeConverter)
  dateLivraison: Date;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateTimeConverter)
  datepaiement: Date;

  @JsonProperty(ModeReglement)
  @Optional
  modeReglement: ModeReglement;

  @JsonProperty(String)
  @Optional
  codeRegion: string;
}
